import { ChangeDetectorRef, Component, Inject, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { Router } from '@angular/router';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Observable, Subscription } from 'rxjs';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { SelectionModel } from '@angular/cdk/collections';
import * as moment from 'moment';
import { N } from '@angular/cdk/keycodes';

import { Clipboard } from "@angular/cdk/clipboard"
import { flatten } from '@angular/compiler';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { DatePipe } from '@angular/common';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { AddTaskTempCategoryComponent } from 'src/app/middleware/common/addTaskTempCategory/addTaskTempCategory.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-task3c',
  templateUrl: './task3c.component.html',
  styleUrls: ['./task3c.component.scss'],
  providers: [DatePipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})


export class Task3CComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  ShowNoRecordFound: boolean = false;
  taskList: any = [] = [];
  subTaskList: any = [] = [];

  value: string = '';
  showCreateTask: boolean = false;
  showTaskDetail: boolean = false;
  showProcess: boolean = false;
  showmyDrive: boolean = true;
  showSub: boolean = false;
  showSub1: boolean = false;

  dataSource: any = [] = [];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = [];

  pageSizeOptions: number[] = [10, 20, 50, 100];
  paginatorTotalLength: any;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };

  taskId: number = 0;

  taskListFolder: any = [] = [];
  selection = new SelectionModel<any>(true, []);
  taskStatusList: any = [] = [];

  dueDatetext: string = 'Due Date';
  //myTaskText:string='Task';
  //myTaskText:string='Assigned to me';
  myTaskText: string = 'All Task';
  preorityArray: any = [];
  isOverDue: boolean = false;
  isDuedate: boolean = false;
  dateFrom: any = null;
  dateTo: any = null;
  preoritytext: string = "Priority";
  IsAssignedToMe: boolean = false;
  IsAssignedToMyRole: boolean = false;
  IsAllTask: boolean = true;
  IsCreatedByMe: boolean = false;
  isMyTaskFilterSelected: boolean = false;
  completedTaskStatusID: any = 0;
  @Input() modulename: string;
  @Input() mainModulename: string;
  @Input() transactionID: number = 0;
  @Input() typeId: number = 0;
  @Input() name: string = "";
  @Input() email: string = "";
  @Input() imageUrl: string = "";
  @Input() entityId: number = 0;
  @Input() TypeIdDrp: number = 0;


  transactionIDForTask: number = 0;
  typeIdForTask: number = 0;
  Module: string;
  mainModuleName: string;
  clickEventsubscription: Subscription;

  moduleNames = "3C"
  clickEventNextPreviousForTaskFromCore: any;

  statusGroup: FormGroup;

  taskStatusColors = ['#8f8f8f', '#4f66ff', '#fdab3d', '#00c875', '#db241c']
  taskPriorityColors = ['#8f8f8f', '#fdab3d', '#e2445c', '#00c875', '#db241c']

  taskPriorityNameColorCode = [
    {
      val: 1,
      name: 'Lowest',
      color: '#8f8f8f',
      icon: 'keyboard_double_arrow_down'
    },
    {
      val: 2,
      name: 'Low',
      color: '#fdab3d',
      icon: 'keyboard_double_arrow_down'
    },
    {
      val: 3,
      name: 'Medium',
      color: '#1dcd33',
      icon: 'keyboard_double_arrow_up'
    },
    {
      val: 4,
      name: 'High',
      color: '#d31e16bf',
      icon: 'keyboard_double_arrow_up'
    },
    {
      val: 5,
      name: 'Highest',
      color: '#db241c',
      icon: 'keyboard_double_arrow_up'
    }
  ]
  isOfficeAdmin: boolean = false;
  isOrganizationAdmin: boolean = false;
  isSuperAdmin: boolean = false;
  rolesAsssign: any[] = [];

  pageSize: number = 300;
  pageIndex: number = 1;

  SingleTaskArchived: boolean = false;


  FieldColumnToogle: any = [] = [];
  folderListForID: any = [] = [];
  ToogleColumnFields: any = [] = [];
  folderId: number = 0;
  ShowCustomColumn: boolean = false;
  FieldColumn: any = [] = [];
  showAddGroupButton: boolean = false;
  showCreateGroup: boolean = false;

  constructor(private dialog: MatDialog, private loaderService: LoaderService,
    private cdr: ChangeDetectorRef, private _dataSharingService: DataSharingService,
    private router: Router, private reusableClass: ReusableClasses,
    private encryptionAlgo: EncryptionService, private statusConst: StatusConstant,
    private taskService: SettingService, private formBuilder: FormBuilder, private coreService: CoreService,
    private toastr: ToastrService, private clipboard: Clipboard, private datePipe: DatePipe,
    private formsService: FormsService, private statusConstant: StatusConstant,
    ) {
    this.statusGroup = new FormGroup({});
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.Module = this.modulename;
    this.mainModuleName = this.mainModulename;
    this.transactionIDForTask = this.transactionID;
    this.typeIdForTask = this.typeId;
  }

  ngOnInit(): void {
    this.clickEventsubscription = this._dataSharingService.getHideTaskListCore().subscribe(() => {
      this.showTaskListsLeft = false;
    });
    this.clickEventNextPreviousForTaskFromCore = this._dataSharingService.getNextPreviousForTaskFrom3C().subscribe((result) => {
      if (result != '') {
        this.taskListID = 0;
        this.getTaskStatus();
        this.setDisplayedColumns();
        this.getTaskList(this.pageModelData);
      }
    });

    this.taskListID = 0;
    this.SingleTaskArchived = false;
    this.showTaskListsLeft = false;

    // this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    // if (this.rolesAsssign.length > 0) {
    //   this.isOfficeAdmin = this.rolesAsssign.find(m => m.roleName == 'Office Admin') != undefined;
    //   this.isOrganizationAdmin = this.rolesAsssign.find(m => m.roleName == 'Organization Admin') != undefined;
    //   this.isSuperAdmin = this.rolesAsssign.find(m => m.roleName == 'Super Admin') != undefined;
    // }

    // if(this.data.taskListID>0){     
    //    this.getTaskStatus();
    //    this.setDisplayedColumns();
    //    this.OpenTaskListsFromSFNDashboard(this.data.taskListID);
    //    return;
    //  }
    this.taskListID = 0;
    this.SingleTaskArchived = false;
    this.showTaskListsLeft = false;
    this.getTaskStatus();
    this.setDisplayedColumns();
    this.getTaskList(this.pageModelData);  

    this.taskService.openTaskTrigger.subscribe(value => {
      if (value != null) {
        if (value.name == "Single Task") {
          this.taskListID = 0;
          this.SingleTaskArchived = true;
          this.getTaskListSingleTask(this.pageModelData);
        } else {
          this.taskListID = 0;
          this.SingleTaskArchived = false;
          this.OpenTaskLists(value);
        }
      }
    });

    this.taskService.openMyTaskTrigger.subscribe(value => {
      if (value != null) {
        this.myTaskText = "All Task";//"Assigned to me";
        this.getMyTask();
      }
    });
  }


  openTaskUrl(list) {
    let params = decodeURIComponent(list.token);
    const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
    let decryptedToken = JSON.parse(tokenm);

    //decryptedToken.isOpenURL = false;
    decryptedToken.UserID = this.currentUser.UID;
    const jsonString = JSON.stringify(decryptedToken)
    const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
    const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

    let URL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
    this.clipboard.copy(URL);
    this.toastr.success("Link Copied Successfully.", '', {
      timeOut: 3000,
    });
  }
  setDisplayedColumns() {
    this.displayedColumns = ["taskTitle", "dueDate", "status", "priority", "Action"];
  }

  getTaskStatus() {
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.loaderService.show();
    this.taskService.taskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskStatusList = this.responseHolder.data;
          this.taskStatusList.map(data => {
            if (data.taskStatusConstantName == 'blocked') {
              data.taskStatusName = 'Stuck';
            }
          });
          let completedTask = this.taskStatusList.find(m => m.taskStatusConstantName == 'completed');
          if (completedTask !== undefined) {
            this.completedTaskStatusID = completedTask.taskStatusID;
          }
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  clearDuedate() {
    this.dueDatetext = 'Due Date';
    this.isDuedate = false;
    this.isOverDue = false;
    this.dateFrom = null;
    this.dateTo = null;
    this.getTaskList(undefined);
  }

  clearPreoority() {
    this.preoritytext = "Priority";
    this.preorityArray = [];
    this.getTaskList(undefined);
  }

  clearFilterByMyTask() {
    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = false;
    this.myTaskText = "";
    this.isMyTaskFilterSelected = false;
    this.getTaskList(undefined);
  }

  getSearchResults() {
    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      "paging": {
        "pageSize": this.pageSize,//pageData.pageSize,
        "pageIndex": this.pageIndex  //pageData.pageIndex,
      },
      filter: {
        IsAssignedToMe: this.IsAssignedToMe,
        IsAssignedToMyRole: this.IsAssignedToMyRole,
        IsCreatedByMe: this.IsCreatedByMe,
        IsAllTask: this.IsAllTask,
        title: this.value,
        description: "",
        attachedTitle: "",
        taskListID: this.taskListID,
        TaskListFolderID: this.taskListFolderID,
        createdOn: {
          from: null,
          to: null
        },
        assignedOn: {
          from: null,
          to: null
        },
        assignees: [
          0
        ],
        Priority: this.preorityArray,
        byDate: {
          from: this.dateFrom,
          to: this.dateTo
        },
        isOverDue: this.isOverDue,
        dueDate: this.isDuedate,
        status: 0,
        attachmentType: 0
      },
      transaction: {
        transactionID: this.transactionIDForTask,
        typeId: this.typeIdForTask
      },
      isArchived: false,
      taskType: 2, // 0-External, 1-Internal ,2-Both
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        // if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
        //   this.dataSource = new MatTableDataSource<any>();      
        //   if(this.transactionIDForTask>0){
        //   this.taskList = response.data.tasks;
        //   }else{
        //     //this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
        //     this.taskList = response.data.tasks;
        //   }

        //   if (this.taskList.length > 0) {
        //     this.taskList.map(state => {

        //       this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

        //       if (state.status == 0) {
        //         this.statusGroup.controls["status" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["status" + state.taskId].setValue(state.status);
        //       }

        //       this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

        //       if (state.priority == 0) {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
        //       }
        //     })
        //   }

        //   if(this.taskList.length > 0){
        //     this.taskList.forEach(state => {
        //       if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
        //         //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
        //         state.dueDate = state.dueDate+'.000Z';
        //      }
        //     }); 
        //   }

        //   this.dataSource.data =this.taskList;
        //   this.dataSource.sort = this.sort;         
        //   if(this.taskList.length>0){
        //     this.ShowNoRecordFound=false;
        //   }else{
        //     this.ShowNoRecordFound=true;
        //    }    
        // }
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          if (response.data.tasks.length > 0) {
            response.data.tasks.map(state => {

              this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

              if (state.status == 0) {
                this.statusGroup.controls["status" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["status" + state.taskId].setValue(state.status);
              }

              this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

              if (state.priority == 0) {
                this.statusGroup.controls["priority" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
              }
            })
          }

          // this.totalTask= response.data.paging.recordCount;     

          if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {

            if (this.pageIndex == 1) {
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);              
              this.taskList = response.data.tasks;
              if (this.taskList.length > 0) {
                this.taskList.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    //  state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                });
              }
            } else {
              var data = []
              data = response.data.tasks;//.filter(m => m.isInternal == true);

              if (data.length > 0) {
                data.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    // state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                  this.taskList.push(state);
                });
              }
              // this.taskList.push(data);
            }
          }
          else {
            this.taskList = response.data.tasks;
          }

          this.dataSource.data = this.taskList;

          this.dataSource.sort = this.sort;

          // let allAssigne: any;

          //   this.taskList.taskAssignedEntity?.map(item => {
          //    allAssigne.push(item.assigneeName)
          //  })
          //  this.taskList.taskAssignedEntity[0].assigneeName = allAssigne.toString();

          this.columns[0].groups = [{
            id: 0,
            title: 'Default Group',
            dragDisabled: true,
            items: this.taskList
          }];

          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
          // this.showLoadingData=false;
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  onFilterByMyTask(type: any, txt: any) {
    this.taskListID = 0;
    this.myTaskText = txt;
    this.isMyTaskFilterSelected = true;
    if (type == 1) {
      this.IsAssignedToMe = false;
      this.IsAssignedToMyRole = false;
      this.IsCreatedByMe = false;
      this.IsAllTask = true;
    }
    else if (type == 2) {
      this.IsAssignedToMe = false;
      this.IsAssignedToMyRole = false;
      this.IsCreatedByMe = true;
      this.IsAllTask = false;
    }
    else if (type == 3) {
      this.IsAssignedToMe = true;
      this.IsAssignedToMyRole = false;
      this.IsCreatedByMe = false;
      this.IsAllTask = false;
    }
    else if (type == 4) {
      this.IsAssignedToMe = false;
      this.IsAssignedToMyRole = true;
      this.IsCreatedByMe = false;
      this.IsAllTask = false;
    }
    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      "paging": {
        "pageSize": this.pageSize,//pageData.pageSize,
        "pageIndex": this.pageIndex  //pageData.pageIndex,
      },
      filter: {
        IsAssignedToMe: this.IsAssignedToMe,
        IsAssignedToMyRole: this.IsAssignedToMyRole,
        IsCreatedByMe: this.IsCreatedByMe,
        IsAllTask: this.IsAllTask,
        title: this.value,
        description: "",
        attachedTitle: "",
        taskListID: 0,//this.taskListID,
        TaskListFolderID: this.taskListFolderID,
        createdOn: {
          from: null,
          to: null
        },
        assignedOn: {
          from: null,
          to: null
        },
        assignees: [
          0
        ],
        Priority: this.preorityArray,
        byDate: {
          from: this.dateFrom,
          to: this.dateTo
        },
        isOverDue: this.isOverDue,
        dueDate: this.isDuedate,
        status: 0,
        attachmentType: 0
      },
      transaction: {
        transactionID: this.transactionID,
        typeId: this.typeIdForTask //1
      },
      isArchived: false,
      taskType: 2, // 0-External, 1-Internal ,2-Both
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        // if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
        //   this.dataSource = new MatTableDataSource<any>();      
        //   if(this.transactionID>0){
        //   this.taskList = response.data.tasks;
        //   }else{
        //     //this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
        //     this.taskList = response.data.tasks;
        //   }

        //   if (this.taskList.length > 0) {
        //     this.taskList.map(state => {

        //       this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

        //       if (state.status == 0) {
        //         this.statusGroup.controls["status" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["status" + state.taskId].setValue(state.status);
        //       }

        //       this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

        //       if (state.priority == 0) {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
        //       }
        //     })
        //   }

        //   if(this.taskList.length > 0){
        //     this.taskList.forEach(state => {
        //       if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
        //         //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
        //         state.dueDate = state.dueDate+'.000Z';
        //      }
        //     }); 
        //   }


        //   this.dataSource.data =this.taskList;
        //   this.dataSource.sort = this.sort;         
        //   if(this.taskList.length>0){
        //     this.ShowNoRecordFound=false;
        //   }else{
        //     this.ShowNoRecordFound=true;
        //    }    
        // }
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          if (response.data.tasks.length > 0) {
            response.data.tasks.map(state => {

              this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

              if (state.status == 0) {
                this.statusGroup.controls["status" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["status" + state.taskId].setValue(state.status);
              }

              this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

              if (state.priority == 0) {
                this.statusGroup.controls["priority" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
              }
            })
          }

          // this.totalTask= response.data.paging.recordCount;     

          if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {

            if (this.pageIndex == 1) {
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);              
              this.taskList = response.data.tasks;
              if (this.taskList.length > 0) {
                this.taskList.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    //  state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                });
              }
            } else {
              var data = []
              data = response.data.tasks;//.filter(m => m.isInternal == true);

              if (data.length > 0) {
                data.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    // state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                  this.taskList.push(state);
                });
              }
              // this.taskList.push(data);
            }
          }
          else {
            this.taskList = response.data.tasks;
          }

          this.dataSource.data = this.taskList;

          this.dataSource.sort = this.sort;

          // let allAssigne: any;

          //   this.taskList.taskAssignedEntity?.map(item => {
          //    allAssigne.push(item.assigneeName)
          //  })
          //  this.taskList.taskAssignedEntity[0].assigneeName = allAssigne.toString();

          this.columns[0].groups = [{
            id: 0,
            title: 'Default Group',
            dragDisabled: true,
            items: this.taskList
          }];

          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
          // this.showLoadingData=false;
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  onFilterByPreority(type: any, txt: any) {
    this.preoritytext = txt;
    this.preorityArray = [];
    this.preorityArray.push(type);
    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      "paging": {
        "pageSize": this.pageSize,//pageData.pageSize,
        "pageIndex": this.pageIndex  //pageData.pageIndex,
      },
      filter: {
        IsAssignedToMe: this.IsAssignedToMe,
        IsAssignedToMyRole: this.IsAssignedToMyRole,
        IsCreatedByMe: this.IsCreatedByMe,
        IsAllTask: this.IsAllTask,
        title: this.value,
        description: "",
        attachedTitle: "",
        taskListID: this.taskListID,
        TaskListFolderID: this.taskListFolderID,
        createdOn: {
          from: null,
          to: null
        },
        assignedOn: {
          from: null,
          to: null
        },
        assignees: [
          0
        ],
        Priority: this.preorityArray,
        byDate: {
          from: this.dateFrom,
          to: this.dateTo
        },
        isOverDue: this.isOverDue,
        dueDate: this.isDuedate,
        status: 0,
        attachmentType: 0
      },
      transaction: {
        transactionID: this.transactionID,
        typeId: this.typeIdForTask //1
      },
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        // if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
        //   this.dataSource = new MatTableDataSource<any>();      
        //   if(this.transactionID>0){
        //     this.taskList = response.data.tasks;
        //   }else{
        //    // this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
        //    this.taskList = response.data.tasks;
        //   }

        //   if (this.taskList.length > 0) {
        //     this.taskList.map(state => {

        //       this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

        //       if (state.status == 0) {
        //         this.statusGroup.controls["status" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["status" + state.taskId].setValue(state.status);
        //       }

        //       this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

        //       if (state.priority == 0) {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
        //       }
        //     })
        //   }

        //   if(this.taskList.length > 0){
        //     this.taskList.forEach(state => {
        //       if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
        //         //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
        //         state.dueDate = state.dueDate+'.000Z';
        //      }
        //     }); 
        //   }


        //   this.dataSource.data =this.taskList;
        //   this.dataSource.sort = this.sort;         
        //   if(this.taskList.length>0){
        //     this.ShowNoRecordFound=false;
        //   }else{
        //     this.ShowNoRecordFound=true;
        //    }    
        // }
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          if (response.data.tasks.length > 0) {
            response.data.tasks.map(state => {

              this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

              if (state.status == 0) {
                this.statusGroup.controls["status" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["status" + state.taskId].setValue(state.status);
              }

              this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

              if (state.priority == 0) {
                this.statusGroup.controls["priority" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
              }
            })
          }

          // this.totalTask= response.data.paging.recordCount;     

          if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {

            if (this.pageIndex == 1) {
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);              
              this.taskList = response.data.tasks;
              if (this.taskList.length > 0) {
                this.taskList.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    //  state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                });
              }
            } else {
              var data = []
              data = response.data.tasks;//.filter(m => m.isInternal == true);

              if (data.length > 0) {
                data.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    // state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                  this.taskList.push(state);
                });
              }
              // this.taskList.push(data);
            }
          }
          else {
            this.taskList = response.data.tasks;
          }

          this.dataSource.data = this.taskList;

          this.dataSource.sort = this.sort;

          // let allAssigne: any;

          //   this.taskList.taskAssignedEntity?.map(item => {
          //    allAssigne.push(item.assigneeName)
          //  })
          //  this.taskList.taskAssignedEntity[0].assigneeName = allAssigne.toString();

          this.columns[0].groups = [{
            id: 0,
            title: 'Default Group',
            dragDisabled: true,
            items: this.taskList
          }];

          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
          // this.showLoadingData=false;
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  GettaskByFilter(type: any) {
    this.isOverDue = false;
    this.isDuedate = true;
    this.dueDatetext = type;
    if (type == 'Today') {
      this.dateFrom = moment().utc().format('YYYY-M-D');
      this.dateTo = moment().utc().format('YYYY-M-D');
    }
    else if (type == 'Tomorrow') {
      this.dateFrom = moment().add(1, 'day').utc().format('YYYY-M-D');
      this.dateTo = moment().add(1, 'day').utc().format('YYYY-M-D');
    }
    else if (type == 'This Week') {
      this.dateFrom = moment().startOf('week').utc().format('YYYY-M-D');
      this.dateTo = moment().endOf('week').utc().format('YYYY-M-D');
    }
    else if (type == 'Next Week') {
      this.dateFrom = moment().add(1, 'week').startOf('week').utc().format('YYYY-M-D');
      this.dateTo = moment().add(1, 'week').endOf('week').utc().format('YYYY-M-D');
    }
    else if (type == 'Overdue') {
      this.isOverDue = true;
      this.dateFrom = moment().utc().format('YYYY-M-D');
      this.dateTo = moment().utc().format('YYYY-M-D');
    }
    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      filter: {
        "paging": {
          "pageSize": this.pageSize,//pageData.pageSize,
          "pageIndex": this.pageIndex  //pageData.pageIndex,
        },
        IsAssignedToMe: this.IsAssignedToMe,
        IsAssignedToMyRole: this.IsAssignedToMyRole,
        IsCreatedByMe: this.IsCreatedByMe,
        IsAllTask: this.IsAllTask,
        title: this.value,
        description: "",
        attachedTitle: "",
        taskListID: this.taskListID,
        TaskListFolderID: this.taskListFolderID,
        createdOn: {
          from: null,
          to: null
        },
        assignedOn: {
          from: null,
          to: null
        },
        assignees: [
          0
        ],
        Priority: this.preorityArray,
        byDate: {
          from: this.dateFrom,
          to: this.dateTo
        },
        isOverDue: this.isOverDue,
        dueDate: this.isDuedate,
        status: 0,
        attachmentType: 0
      },
      transaction: {
        transactionID: this.transactionID,
        typeId: this.typeIdForTask //1
      },
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        // if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
        //   this.dataSource = new MatTableDataSource<any>();      
        //   if(this.transactionID>0){
        //      this.taskList = response.data.tasks;
        //   }else{
        //    // this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
        //     this.taskList = response.data.tasks;
        //   }

        //   if (this.taskList.length > 0) {
        //     this.taskList.map(state => {

        //       this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

        //       if (state.status == 0) {
        //         this.statusGroup.controls["status" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["status" + state.taskId].setValue(state.status);
        //       }

        //       this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

        //       if (state.priority == 0) {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
        //       }
        //     })
        //   }

        //   if(this.taskList.length > 0){
        //     this.taskList.forEach(state => {
        //       if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
        //         //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
        //         state.dueDate = state.dueDate+'.000Z';
        //      }
        //     }); 
        //   }


        //   this.dataSource.data =this.taskList;
        //   this.dataSource.sort = this.sort;         
        //   if(this.taskList.length>0){
        //     this.ShowNoRecordFound=false;
        //   }else{
        //     this.ShowNoRecordFound=true;
        //    }    
        // }
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          if (response.data.tasks.length > 0) {
            response.data.tasks.map(state => {

              this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

              if (state.status == 0) {
                this.statusGroup.controls["status" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["status" + state.taskId].setValue(state.status);
              }

              this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

              if (state.priority == 0) {
                this.statusGroup.controls["priority" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
              }
            })
          }

          // this.totalTask= response.data.paging.recordCount;     

          if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {

            if (this.pageIndex == 1) {
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);              
              this.taskList = response.data.tasks;
              if (this.taskList.length > 0) {
                this.taskList.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    //  state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                });
              }
            } else {
              var data = []
              data = response.data.tasks;//.filter(m => m.isInternal == true);

              if (data.length > 0) {
                data.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    // state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                  this.taskList.push(state);
                });
              }
              // this.taskList.push(data);
            }
          }
          else {
            this.taskList = response.data.tasks;
          }

          this.dataSource.data = this.taskList;

          this.dataSource.sort = this.sort;

          // let allAssigne: any;

          //   this.taskList.taskAssignedEntity?.map(item => {
          //    allAssigne.push(item.assigneeName)
          //  })
          //  this.taskList.taskAssignedEntity[0].assigneeName = allAssigne.toString();

          this.columns[0].groups = [{
            id: 0,
            title: 'Default Group',
            dragDisabled: true,
            items: this.taskList
          }];

          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
          // this.showLoadingData=false;
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  MyTaskFunction() {
    this.dueDatetext = 'Due Date';
    this.taskListFolderID = 0;
    this.taskListID = 0;
    this.isDuedate = false;
    this.isOverDue = false;
    this.dateFrom = null;
    this.dateTo = null;
    this.preoritytext = "Priority";
    this.preorityArray = [];
    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = false;
    this.myTaskText = "Task";
    this.isMyTaskFilterSelected = false;
    this.getTaskList(undefined);
  }

  clearSerachText() {
    this.value = '';
    this.getTaskList(undefined);
  }

  getTaskList(pageData: any) {
    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      "paging": {
        "pageSize": this.pageSize,//pageData.pageSize,
        "pageIndex": this.pageIndex  //pageData.pageIndex,
      },
      filter: {
        IsAssignedToMe: this.IsAssignedToMe,
        IsAssignedToMyRole: this.IsAssignedToMyRole,
        IsCreatedByMe: this.IsCreatedByMe,
        IsAllTask: this.IsAllTask,
        title: this.value,
        description: "",
        attachedTitle: "",
        taskListID: this.taskListID,
        TaskListFolderID: this.taskListFolderID,
        createdOn: {
          from: null,
          to: null
        },
        assignedOn: {
          from: null,
          to: null
        },
        assignees: [
          0
        ],
        Priority: this.preorityArray,
        byDate: {
          from: this.dateFrom,
          to: this.dateTo
        },
        isOverDue: this.isOverDue,
        dueDate: this.isDuedate,
        status: 0,
        attachmentType: 0
      },
      transaction: {
        transactionID: this.transactionID,
        typeId: this.typeIdForTask //1
      },
      isArchived: false,
      taskType: 2, // 0-External, 1-Internal ,2-Both
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.taskList = [];
        this.loaderService.hide();
        // if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
        //  // this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
        //  this.taskList = response.data.tasks;
        //   this.dataSource = new MatTableDataSource<any>(); 
        //   if(this.transactionID>0){
        //     this.taskList = response.data.tasks;
        //   }else {
        //     this.taskList = response.data.tasks;
        //    // this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
        //   }

        //   if (this.taskList.length > 0) {
        //     this.taskList.map(state => {

        //       this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

        //       if (state.status == 0) {
        //         this.statusGroup.controls["status" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["status" + state.taskId].setValue(state.status);
        //       }

        //       this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

        //       if (state.priority == 0) {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
        //       }
        //     })
        //   }

        //   if(this.taskList.length > 0){
        //     this.taskList.forEach(state => {
        //       if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
        //         //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
        //         state.dueDate = state.dueDate+'.000Z';
        //      }
        //     }); 
        //   }

        //   this.dataSource.data =this.taskList;
        //   this.dataSource.sort = this.sort;    
        //    if(this.taskList.length>0){
        //     this.ShowNoRecordFound=false;
        //   }else{
        //     this.ShowNoRecordFound=true;
        //    }    
        // }

        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          if (response.data.tasks.length > 0) {
            response.data.tasks.map(state => {

              this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

              if (state.status == 0) {
                this.statusGroup.controls["status" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["status" + state.taskId].setValue(state.status);
              }

              this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

              if (state.priority == 0) {
                this.statusGroup.controls["priority" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
              }
            })
          }

          // this.totalTask= response.data.paging.recordCount;     

          if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {

            if (this.pageIndex == 1) {
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);              
              this.taskList = response.data.tasks;
              if (this.taskList.length > 0) {
                this.taskList.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    //  state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                });
              }
            } else {
              var data = []
              data = response.data.tasks;//.filter(m => m.isInternal == true);

              if (data.length > 0) {
                data.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    // state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                  this.taskList.push(state);
                });
              }
              // this.taskList.push(data);
            }
          }
          else {
            this.taskList = response.data.tasks;
          }

          this.dataSource.data = this.taskList;

          this.dataSource.sort = this.sort;

          // let allAssigne: any;

          //   this.taskList.taskAssignedEntity?.map(item => {
          //    allAssigne.push(item.assigneeName)
          //  })
          //  this.taskList.taskAssignedEntity[0].assigneeName = allAssigne.toString();

          this.columns[0].groups = [{
            id: 0,
            title: 'Default Group',
            dragDisabled: true,
            items: this.taskList
          }];

          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
          // this.showLoadingData=false;
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }


  getTaskListSingleTask(pageData: any) {
    this.ShowNoRecordFound = false;

    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = true;
    this.taskListID = 0;
    this.taskListFolderID = 0;

    this.loaderService.show();
    var ReqModel = {
      "paging": {
        "pageSize": this.pageSize,//pageData.pageSize,
        "pageIndex": this.pageIndex  //pageData.pageIndex,
      },
      filter: {
        IsAssignedToMe: this.IsAssignedToMe,
        IsAssignedToMyRole: this.IsAssignedToMyRole,
        IsCreatedByMe: this.IsCreatedByMe,
        IsAllTask: this.IsAllTask,
        title: this.value,
        description: "",
        attachedTitle: "",
        taskListID: this.taskListID,
        TaskListFolderID: this.taskListFolderID,
        createdOn: {
          from: null,
          to: null
        },
        assignedOn: {
          from: null,
          to: null
        },
        assignees: [
          0
        ],
        Priority: this.preorityArray,
        byDate: {
          from: this.dateFrom,
          to: this.dateTo
        },
        isOverDue: this.isOverDue,
        dueDate: this.isDuedate,
        status: 0,
        attachmentType: 0
      },
      transaction: {
        transactionID: this.transactionID,
        typeId: this.typeIdForTask //1
      },
      isArchived: true,
      taskType: 2, // 0-External, 1-Internal ,2-Both
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        this.taskList = [];
        // if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
        //   //this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
        //   this.taskList = response.data.tasks;
        //   this.dataSource = new MatTableDataSource<any>(); 
        //   if(this.transactionID>0) {
        //   this.taskList = response.data.tasks;
        //   }else{
        //     this.taskList = response.data.tasks;
        //    // this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
        //   }

        //   if (this.taskList.length > 0) {
        //     this.taskList.map(state => {

        //       this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

        //       if (state.status == 0) {
        //         this.statusGroup.controls["status" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["status" + state.taskId].setValue(state.status);
        //       }

        //       this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

        //       if (state.priority == 0) {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
        //       }
        //     })
        //   }

        //   if(this.taskList.length > 0){
        //     this.taskList.forEach(state => {
        //       if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
        //         //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
        //         state.dueDate = state.dueDate+'.000Z';
        //      }
        //     }); 
        //   }

        //   this.dataSource.data =this.taskList;
        //   this.dataSource.sort = this.sort;    
        //    if(this.taskList.length>0){
        //     this.ShowNoRecordFound=false;
        //   }else{
        //     this.ShowNoRecordFound=true;
        //    }    
        // }
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          if (response.data.tasks.length > 0) {
            response.data.tasks.map(state => {

              this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

              if (state.status == 0) {
                this.statusGroup.controls["status" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["status" + state.taskId].setValue(state.status);
              }

              this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

              if (state.priority == 0) {
                this.statusGroup.controls["priority" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
              }
            })
          }

          // this.totalTask= response.data.paging.recordCount;     

          if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {

            if (this.pageIndex == 1) {
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);              
              this.taskList = response.data.tasks;
              if (this.taskList.length > 0) {
                this.taskList.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    //  state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                });
              }
            } else {
              var data = []
              data = response.data.tasks;//.filter(m => m.isInternal == true);

              if (data.length > 0) {
                data.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    // state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                  this.taskList.push(state);
                });
              }
              // this.taskList.push(data);
            }
          }
          else {
            this.taskList = response.data.tasks;
          }

          this.dataSource.data = this.taskList;

          this.dataSource.sort = this.sort;

          // let allAssigne: any;

          //   this.taskList.taskAssignedEntity?.map(item => {
          //    allAssigne.push(item.assigneeName)
          //  })
          //  this.taskList.taskAssignedEntity[0].assigneeName = allAssigne.toString();

          this.columns[0].groups = [{
            id: 0,
            title: 'Default Group',
            dragDisabled: true,
            items: this.taskList
          }];

          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
          // this.showLoadingData=false;
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  getStatusName(statusId) {
    var checkstatus: any = [];
    checkstatus = this.taskStatusList.filter(x => x.taskStatusID == statusId);
    if (checkstatus.length > 0) {
      return checkstatus[0].taskStatusName;
    } else {
      return "NA";
    }
  }



  getBackground(stat) {
    switch (stat) {
      case 1:
        return this.taskStatusColors[0];

      case 2:
        return this.taskStatusColors[1];

      case 3:
        return this.taskStatusColors[2];

      case 4:
        return this.taskStatusColors[3];

      case 5:
        return this.taskStatusColors[4];

      default:
        return "#000000"

    }

  }

  deleteTask(task) {
    const message = `Are you sure you want to delete this task?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var taskId = 0;
          if (task.taskId == undefined) {
            taskId = task.taskID;
          } else {
            taskId = task.taskId;
          }
          var reqModel = {
            taskIds: [taskId],
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.removeTasks(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                if (this.taskListID == 0) {
                  this.getTaskList(this.pageModelData);
                } else {
                  this.getTaskByTaskList();
                }
                this.loaderService.hide();
                this.toastr.success('Task deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }




  deleteMultipleTask() {
    const message = `Are you sure you want to delete selected task?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var selectedtasklist = [];
          if (this.selectedRecordMoveToArray.length > 0) {
            for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i) {
              const taskid = this.selectedRecordMoveToArray[i].selectedRecord;
              selectedtasklist.push(taskid);
            }
          }
          var reqModel = {
            taskIds: selectedtasklist,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.removeTasks(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                if (this.taskListID == 0) {
                  this.getTaskList(this.pageModelData);
                } else {
                  this.getTaskByTaskList();
                }
                this.showMoveToOption = false;
                this.selectedRecordMoveToArray = [];
                this.selection.clear();
                this.loaderService.hide();
                this.toastr.success('Task deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.showMoveToOption = false;
                this.selectedRecordMoveToArray = [];
                this.selection.clear();
                this.loaderService.hide();
                this.toastr.error('Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.showMoveToOption = false;
              this.selectedRecordMoveToArray = [];
              this.selection.clear();
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  showMyDrive() {
    this.showmyDrive = !this.showmyDrive;
  }

  showTaskListsLeft: boolean = false;

  showTaskLists() {
    this.showTaskListsLeft = !this.showTaskListsLeft;
  }

  createNewTask() {
    this.taskId = 0;
    this.showCreateTask = true;
  }

  closeCreateTask(messages: boolean) {
    this.showCreateTask = messages;
  }


  getCloseCreateTask() {
    this.showCreateTask = false;
  }

  getSaveTask() {
    if (this.taskListID == 0) {
      this.getTaskList(this.pageModelData);
    }
    if (this.taskListID > 0) {
      this.getTaskByTaskList();
    }
  }

  getMyTask() {
    this.dueDatetext = 'Due Date';
    this.taskListFolderID = 0;
    this.taskListID = 0;
    this.isDuedate = false;
    this.isOverDue = false;
    this.dateFrom = null;
    this.dateTo = null;
    this.preoritytext = "Priority";
    this.preorityArray = [];
    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = true;
    this.myTaskText = "All Task";//"Assigned to me";
    this.isMyTaskFilterSelected = false;

    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      "paging": {
        "pageSize": this.pageSize,//pageData.pageSize,
        "pageIndex": this.pageIndex  //pageData.pageIndex,
      },
      filter: {
        IsAssignedToMe: this.IsAssignedToMe,
        IsAssignedToMyRole: this.IsAssignedToMyRole,
        IsCreatedByMe: this.IsCreatedByMe,
        IsAllTask: this.IsAllTask,
        title: this.value,
        description: "",
        attachedTitle: "",
        taskListID: this.taskListID,
        TaskListFolderID: this.taskListFolderID,
        createdOn: {
          from: null,
          to: null
        },
        assignedOn: {
          from: null,
          to: null
        },
        assignees: [
          0
        ],
        Priority: this.preorityArray,
        byDate: {
          from: this.dateFrom,
          to: this.dateTo
        },
        isOverDue: this.isOverDue,
        dueDate: this.isDuedate,
        status: 0,
        attachmentType: 0
      },
      transaction: {
        transactionID: this.transactionIDForTask,
        typeId: this.typeIdForTask
      },
      isArchived: false,
      taskType: 2, // 0-External, 1-Internal ,2-Both
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.taskList = [];
        this.loaderService.hide();
        // if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
        //   this.dataSource = new MatTableDataSource<any>();   
        //   if(this.transactionIDForTask>0){
        //   this.taskList = response.data.tasks;
        //   }
        //   else {
        //     this.taskList = response.data.tasks;
        //    // this.taskList = response.data.tasks.filter(m=>m.isInternal==true);
        //   }


        //   if (this.taskList.length > 0) {
        //     this.taskList.map(state => {

        //       this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

        //       if (state.status == 0) {
        //         this.statusGroup.controls["status" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["status" + state.taskId].setValue(state.status);
        //       }

        //       this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

        //       if (state.priority == 0) {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(1);
        //       } else {
        //         this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
        //       }
        //     })
        //   }

        //   if(this.taskList.length > 0){
        //     this.taskList.forEach(state => {
        //       if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
        //         //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
        //         state.dueDate = state.dueDate+'.000Z';
        //      }
        //     }); 
        //   }


        //   this.dataSource.data =this.taskList;
        //   this.dataSource.sort = this.sort;     
        //    if(this.taskList.length>0){
        //     this.ShowNoRecordFound=false;
        //   }else{
        //     this.ShowNoRecordFound=true;
        //    }    
        // }
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          if (response.data.tasks.length > 0) {
            response.data.tasks.map(state => {

              this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

              if (state.status == 0) {
                this.statusGroup.controls["status" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["status" + state.taskId].setValue(state.status);
              }

              this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

              if (state.priority == 0) {
                this.statusGroup.controls["priority" + state.taskId].setValue(1);
              } else {
                this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
              }
            })
          }

          // this.totalTask= response.data.paging.recordCount;     

          if (ReqModel.filter != null && ReqModel.filter != undefined && ReqModel.filter.taskListID == 0) {

            if (this.pageIndex == 1) {
              //this.taskList = response.data.tasks.filter(m => m.isInternal == true);              
              this.taskList = response.data.tasks;
              if (this.taskList.length > 0) {
                this.taskList.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    //  state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                });
              }
            } else {
              var data = []
              data = response.data.tasks;//.filter(m => m.isInternal == true);

              if (data.length > 0) {
                data.forEach(state => {
                  if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                    // state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                    state.dueDate = state.dueDate + '.000Z';
                  }
                  this.taskList.push(state);
                });
              }
              // this.taskList.push(data);
            }
          }
          else {
            this.taskList = response.data.tasks;
          }

          this.dataSource.data = this.taskList;

          this.dataSource.sort = this.sort;

          // let allAssigne: any;

          //   this.taskList.taskAssignedEntity?.map(item => {
          //    allAssigne.push(item.assigneeName)
          //  })
          //  this.taskList.taskAssignedEntity[0].assigneeName = allAssigne.toString();

          this.columns[0].groups = [{
            id: 0,
            title: 'Default Group',
            dragDisabled: true,
            items: this.taskList
          }];

          if (this.taskList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
          // this.showLoadingData=false;
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  showAddGroupButtonCore: boolean = false;

  getTaskDetail(task: any) {
    const body = document.body;
    body.classList.add('removeTabarrows');

    if (this.taskListID == 0) {
      this.showAddGroupButtonCore = false;
    }
    if (this.taskListID > 0) {
      this.showAddGroupButtonCore = true;
    }
    if (task.taskId == undefined) {
      this.taskId = task.taskID;
    } else {
      this.taskId = task.taskId;
    }
    this.showTaskDetail = true;
  }

  closeTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
    const body = document.body;
    body.classList.remove('removeTabarrows');
  }

  closeTaskList(messages: boolean) {
    this.showTaskListsLeft = messages;
  }

  closeSaveTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
    if (this.taskListID == 0) {
      this.getTaskList(this.pageModelData);
    }
    if (this.taskListID > 0) {
      this.getTaskByTaskList();
    }
  }

  showPIntelligence(messages: boolean) {
    this.showProcess = messages;
  }

  closePIntelligence(messages: boolean) {
    this.showProcess = messages;
  }

  showSubtask() {
    this.showSub = !this.showSub;
  }

  showSubtask1() {
    this.showSub1 = !this.showSub1;
  }



  closeTemplate() {
    this.taskListFolderID = 0;
    this.selectedTaskCategoryID = 0;
    // this.searchTemplateName="";
    this.dialog.closeAll();
  }

  close() {
    this.taslTemplateID = 0;
    this.myfolderForm.reset();
    this.taskListFolderID = 0;
    // this.taskListID=0;
    this.dialog.closeAll();
  }

  closeSaveAsTemplate() {
    this.taslTemplateID = 0;
    this.addTemplateForm.reset();
    this.taskListFolderID = 0;
    // this.taskListID=0;
    this.dialog.closeAll();
  }

  assignUser(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'selectParticipants',
    });
  }



  taskComplete: boolean = false;

  markComplete(task: any) {
    if (task.status !== this.completedTaskStatusID)
      this.completeTask(task);
  }

  selectedTaskOption: any
  showAssignedTask = false;
  showReminderTask = false;
  showScheduleTask = false;
  showAttachTask = false;

  addTaskOption(val: string, task: any) {

    this.taskId = task.taskId;

    if (val === 'Assigned') {
      this.showAssignedTask = true;

      this.showReminderTask = false;
      this.showScheduleTask = false;
      this.showAttachTask = false;
    }
    if (val === 'Reminder') {
      this.showReminderTask = true;

      this.showAssignedTask = false;
      this.showScheduleTask = false;
      this.showAttachTask = false;
    }
    if (val === 'Schedule') {
      this.showScheduleTask = true;

      this.showAssignedTask = false;
      this.showReminderTask = false;
      this.showAttachTask = false;
    }
    if (val === 'Attach') {
      this.showAttachTask = true;

      this.showAssignedTask = false;
      this.showReminderTask = false;
      this.showScheduleTask = false;
    }

  }

  // addSubTaskOption(task:any){
  //   this.taskId=task.taskId;
  //   this.showCreateTask = true;
  // }

  closeTask(val: boolean) {
    this.showAssignedTask = val
  }

  closeReminder(val: boolean) {
    this.showReminderTask = val
  }

  closeSchedule(val: boolean) {
    this.showScheduleTask = val
  }

  closeAttach(val: boolean) {
    this.showAttachTask = val
  }


  //================For Left Side Panel  TaskFolder ========================//


  folderortask: string = "";
  folderTaskName: string = "";

  myfolderForm: FormGroup;
  addTemplateForm: FormGroup;
  spinner: boolean = false;
  taskListFolderID: number = 0;
  taskListID: number = 0;
  taskLists: any = [] = [];
  expandedIndex: number = 0;
  expandedIndexmoveTo: number = 0;

  // getTaskListFolders() {
  //   this.loaderService.show();
  //   var ReqModel={
  //      userID: this.currentUser.UID,     
  //      officeID: this.myOfficeID,    
  //      organizationID: Number(this.organizationId),
  //      officeIDList: this.OfficeIDList,
  //      databaseID:this.databaseId    
  //   }     
  //   this.taskService.getTaskListFolders(ReqModel).subscribe(response => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       this.loaderService.hide();
  //       if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
  //         this.taskListFolder = response.data.taskListFolders;          
  //       }
  //       else {        
  //         this.taskListFolder=[];             
  //         this.loaderService.hide();
  //       }
  //     }
  //     else {       
  //       this.taskListFolder=[];
  //       this.loaderService.hide();
  //     }
  //   });
  // }

  completeTask(task) {
    this.loaderService.show();
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      TaskID: task.taskId,
      status: this.completedTaskStatusID,
      databaseID: this.databaseId
    }
    this.taskService.UpdateTaskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          task.status = this.completedTaskStatusID;
          this.toastr.success("Completed successfully.")
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }



  addTaskListButton: boolean = false;
  TaskListName: string = "";
  taskCategoryList: any[] = [];
  selectedTaskCategoryID: number = 0;




  getActiveTaskTemplateCategories() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.taskService.getActiveTaskTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskCategoryList = response.data;
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
        }
        else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      }
      else {
        this.taskCategoryList = [];
        this.filteredTaskCategoryList = [];
      }
    });
  }

  onTaskListNameChange(searchValue: string): void {
    if (searchValue.trim() == "") {
      this.addTaskListButton = false;
    } else {
      this.TaskListName = searchValue.trim();
      this.addTaskListButton = true;
    }
  }



  taskListFolderIDForUpdate: number = 0;

  createSaveAsTaskTemplate(): void {
    this.addTemplateForm = this.formBuilder.group({
      taskTemplateName: ['', [Validators.required]],
      folderID: ['', [Validators.required]],
    },);
  }


  taslTemplateID: number = 0;
  currentTaskList: number = 0;
  taskListSelected = false;

  getTaskLists(tasklist: any, index: number) {
    if (this.currentTaskList == index) {
      this.taskListSelected = !this.taskListSelected;
    } else {
      this.taskListSelected = true;
    }

    this.currentTaskList = index;

    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    // this.taskListID=0;
    this.showMoveToOption = false;
    // this.getTaskList(this.pageModelData);
    this.taskLists = [];
    this.expandedIndex = index;
    //this.loaderService.show();
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.taskListFolderID = tasklist.taskListFolderID;
    var ReqModel = {
      folderID: tasklist.taskListFolderID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskLists(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskLists = response.data.taskLists;
          this.loaderService.hide();
        }
        else {
          this.taskLists = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskLists = [];
        this.loaderService.hide();
      }
    });
  }


  getTaskLists1(tasklist: any, index: number) {

    if (this.currentTaskList == index) {
      this.taskListSelected = !this.taskListSelected;
    } else {
      this.taskListSelected = true;
    }

    this.currentTaskList = index;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.expandedIndex = index;
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.taskListFolderID = tasklist.taskListFolderID;
  }












  //======Open Task List===========//

  OpenTaskList(Tasklist: any, isArchieved) {
    this.taskListID = Tasklist.taskListID;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.getTaskByTaskList();
  }

  OpenTaskLists(Tasklist: any) {
    this.taskListID = Tasklist.taskListID;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.getTaskByTaskList();
  }

  OpenTaskListsFromSFNDashboard(taskListID: number) {
    this.taskListID = taskListID;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.dueDatetext = 'Due Date';
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.getTaskByTaskList();
  }

  reSetFormURL(taskId: any, formURL: any) {
    if (formURL !== '' && formURL != null) {
      const getToken = formURL.split("token=")[1];
      if (getToken !== undefined) {
        const params = decodeURIComponent(getToken);
        const encrptedToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
        const decryptedToken = JSON.parse(encrptedToken)
        decryptedToken.taskID = taskId
        const jsonString = JSON.stringify(decryptedToken)
        const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
        const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);
        const finalFormURL = formURL.split("token=")[0] + "token=" + encryptedTokenWithEncoding;
        return finalFormURL;
      }
      return formURL;
    }
  }

  getTaskByTaskList() {
    this.dueDatetext = 'Due Date';
    this.isDuedate = false;
    this.isOverDue = false;
    this.dateFrom = null;
    this.dateTo = null;
    this.preoritytext = "Priority";
    this.myTaskText = "Task";
    this.preorityArray = [];
    this.IsAssignedToMe = false;
    this.IsAssignedToMyRole = false;
    this.IsCreatedByMe = false;
    this.IsAllTask = false;
    this.isMyTaskFilterSelected = false;

    this.ShowNoRecordFound = false;
    this.loaderService.show();
    var ReqModel = {
      taskListID: this.taskListID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.GetTaskGroupsByTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.taskList = [];
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.dataSource = new MatTableDataSource<any>();
          this.myTaskText = response.data.taskListName;
          this.columns = JSON.parse(JSON.stringify(this.columnsCopy));
          if (response.data.taskGroups !== undefined && response.data.taskGroups !== null) {
            response.data.taskGroups = response.data.taskGroups.sort(function (a, b) {
              return a.groupPosition - b.groupPosition;
            });

            const taskFil = response.data.taskGroups.filter(x => x.tasks.length > 0)
            taskFil.map(data => {
              data.tasks.forEach(state => {
                this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

                if (state.status == 0) {
                  this.statusGroup.controls["status" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["status" + state.taskId].setValue(state.status);
                }
                this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

                if (state.priority == 0) {
                  this.statusGroup.controls["priority" + state.taskId].setValue(1);
                } else {
                  this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
                }
                if (state.dueDate != null && state.dueDate != undefined && state.dueDate != "") {
                  //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
                  state.dueDate = state.dueDate + '.000Z';
                }
              })
            })

            response.data.taskGroups.forEach(tg => {

              if (tg.tasks !== undefined && tg.tasks !== null) {
                tg.tasks.forEach(ts => {
                  ts.formLink = this.reSetFormURL(ts.taskId, ts.formLink);
                  if (ts.dueDate != null && ts.dueDate != undefined && ts.dueDate != "") {
                    ts.dueDate = moment(ts.dueDate).local().format('YYYY-MM-DD');
                  }
                });
                tg.tasks = tg.tasks.sort(function (a, b) {
                  return a.position - b.position;
                });
              }
              this.columns[0].groups.push({
                id: tg.taskGroupId,
                title: tg.taskGroupName == "Undefined" ? 'Default Group' : tg.taskGroupName,
                items: tg.tasks,
                dragDisabled: tg.taskGroupName == "Undefined" ? true : false,
                groupPosition: tg.groupPosition,
                isTriggered: tg.isTriggered,
                groupType: tg.groupType
              });
            });
          }

          this.taskList = response.data.getTaskDetailResponseDTOs;
          this.FieldColumnToogle = response.data.gridSettings;
          this.FieldColumn = response.data.gridSettings;

          if (this.FieldColumn.length > 0) {
            this.FieldColumn = this.FieldColumn.filter(x => x.isDisplay == true);
          }

          if (response.data.taskGroups.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }

          if (response.data.taskGroups.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
          // this.taskListForGroupTrigger=response.data.taskGroups;
          // if (response.data.taskGroups.length > 0) {
          //   this.checkIsEntityAttached(response.data.taskGroups);
          // }

          // this.dataSource = new MatTableDataSource<any>(); 
          // if(response.data.getTaskDetailResponseDTOs!==undefined && response.data.getTaskDetailResponseDTOs!==null && response.data.getTaskDetailResponseDTOs.length>0)
          // {
          //   response.data.getTaskDetailResponseDTOs.forEach(tls => {
          //     tls.formLink=this.reSetFormURL(tls.taskId,tls.formLink);
          //   });
          // }  

          // this.taskList = response.data.getTaskDetailResponseDTOs;

          // if (this.taskList.length > 0) {
          //   this.taskList.map(state => {

          //     this.statusGroup.addControl("status" + state.taskId, this.formBuilder.control(''));

          //     if (state.status == 0) {
          //       this.statusGroup.controls["status" + state.taskId].setValue(1);
          //     } else {
          //       this.statusGroup.controls["status" + state.taskId].setValue(state.status);
          //     }

          //     this.statusGroup.addControl("priority" + state.taskId, this.formBuilder.control(''));

          //     if (state.priority == 0) {
          //       this.statusGroup.controls["priority" + state.taskId].setValue(1);
          //     } else {
          //       this.statusGroup.controls["priority" + state.taskId].setValue(state.priority);
          //     }
          //   })
          // }

          // if(this.taskList.length > 0){
          //   this.taskList.forEach(state => {
          //     if (state.dueDate!=null && state.dueDate!=undefined && state.dueDate!="") {
          //       //state.dueDate = moment(state.dueDate).local().format('YYYY-MM-DD');
          //       state.dueDate = state.dueDate+'.000Z';
          //    }
          //   }); 
          // }

          // this.dataSource.data =this.taskList;
          // this.dataSource.sort = this.sort;               
          // if(this.taskList.length>0){
          //   this.ShowNoRecordFound=false;
          // }else{
          //   this.ShowNoRecordFound=true;
          // }    
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskList = [];
          this.dataSource.data = [];
          this.loaderService.hide();
        }
      }
      else {
        this.paginatorTotalLength = 0;
        this.ShowNoRecordFound = true;
        this.taskList = [];
        this.loaderService.hide();
      }
    });
  }

  openTaskListUrl(list, isOpen = false) {
    if (list.token != null && isOpen == false) {
      let params = decodeURIComponent(list.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
      let decryptedToken = JSON.parse(tokenm);

      decryptedToken.isOpenURL = false;
      const jsonString = JSON.stringify(decryptedToken)
      const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
      const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

      let URL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
      this.clipboard.copy(URL);
      this.toastr.success("Link Copied.", '', {
        timeOut: 3000,
      });

    }
    else if (list.token != null && isOpen == true) {
      let params = decodeURIComponent(list.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
      let decryptedToken = JSON.parse(tokenm);

      decryptedToken.isOpenURL = true;
      decryptedToken.email = sessionStorage.getItem('email');
      const jsonString = JSON.stringify(decryptedToken)
      const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
      const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

      let URL = window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
      window.open(URL, '_blank');

    }
  }


  dropTable(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.dataSource.data, event.previousIndex, event.currentIndex);
    var itemList = [];
    if (this.dataSource.data.length > 0) {
      for (var i = 0, len = this.dataSource.data.length; i < len; ++i) {
        var obj = {
          taskID: this.dataSource.data[i].taskId,
          position: i + 1
        }
        itemList.push(obj);
      }
    }
    var ReqModel = {
      taskListID: this.taskListID,
      tasks: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.taskService.reorderTasksLists(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getTaskByTaskList();
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  closeMoveto() {
    this.dialog.closeAll();
  }

  selectedRecordMoveToArray: any = [] = [];
  showMoveToOption: boolean = false;
  ButtonForMoveTo: boolean = false;
  taskListIDMoveTo: number = 0;
  taskListFolderForMoveTo: any = [] = [];
  taskListsForMoveTo: any = [] = [];
  showAllCheckBoxes = false;

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    this.showAllCheckBoxes = !this.showAllCheckBoxes;
    return numSelected === numRows;
    // const numSelected = this.selection.selected.length;
    // const numRows = this.dataSource.data.length;
    // this.showAllCheckBoxes = !this.showAllCheckBoxes;
    // return numSelected === numRows;
  }

  isAllSelectedNew() {
    const numSelected = this.selection.selected.length;
    let numRows = 0;
    this.columns[0].groups.forEach(grp => {
      numRows = numRows + grp.items.length;
    });
    this.showAllCheckBoxes = !this.showAllCheckBoxes;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => {
        this.selection.select(row)
      });
    this.selectedRecordMoveToArray = [];

    if (this.selection.selected.length > 0) {
      for (let i = 0; i < this.selection.selected.length; i++) {
        var taskId;
        if (this.selection.selected[i].taskId == undefined) {
          taskId = this.selection.selected[i].taskID;
        } else {
          taskId = this.selection.selected[i].taskId;
        }
        let ReqModel = {
          selectedRecord: taskId
        };
        this.selectedRecordMoveToArray.push(ReqModel);
      }
      this.showMoveToOption = true;
    }
    else {
      this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
    }
  }

  masterToggleNew() {
    this.isAllSelectedNew() ?
      this.selection.clear() :
      this.columns[0].groups.forEach(grp => {
        grp.items.forEach(row => {
          this.selection.select(row)
        });
      });
    this.selectedRecordMoveToArray = [];

    if (this.selection.selected.length > 0) {
      for (let i = 0; i < this.selection.selected.length; i++) {
        var taskId;
        if (this.selection.selected[i].taskId == undefined) {
          taskId = this.selection.selected[i].taskID;
        } else {
          taskId = this.selection.selected[i].taskId;
        }
        let ReqModel = {
          selectedRecord: taskId//this.selection.selected[i].taskId
        };
        this.selectedRecordMoveToArray.push(ReqModel);
      }
      this.showMoveToOption = true;
    }
    else {
      this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
    }
  }

  isAllSelectedRow(event, element) {
    var taskId;
    if (element.taskId == undefined) {
      taskId = element.taskID;
    } else {
      taskId = element.taskId;
    }
    let ReqModel = {
      selectedRecord: taskId
    };
    if (event.checked) {
      this.selectedRecordMoveToArray.push(ReqModel);
    } else {
      let removeIndex = this.selectedRecordMoveToArray.findIndex((itm) => itm.selectedRecord === taskId);
      if (removeIndex !== -1) this.selectedRecordMoveToArray.splice(removeIndex, 1);
    }
    if (this.selectedRecordMoveToArray.length > 0) {
      this.showMoveToOption = true;
    }
    else {
      this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
    }
  }

  // isAllSelectedRow(event, element) {
  //   var taskId;
  //   if (element.taskId == undefined) {
  //     taskId = element.taskID;
  //   } else {
  //     taskId = element.taskId;
  //   }
  //   let ReqModel = {
  //     selectedRecord: taskId,//element.taskId
  //     isRequired:element.isRequired
  //   };
  //   if (event.checked) {
  //     this.selectedRecordMoveToArray.push(ReqModel);
  //   } else {
  //     let removeIndex = this.selectedRecordMoveToArray.findIndex((itm) => itm.selectedRecord === taskId);
  //     if (removeIndex !== -1) this.selectedRecordMoveToArray.splice(removeIndex, 1);
  //   }
  //   if (this.selectedRecordMoveToArray.length > 0) {
  //     this.showMoveToOption = true;
  //   }
  //   else {
  //     this.showMoveToOption = false;
  //     this.selectedRecordMoveToArray = [];
  //   }
  // }

  moveTo(templateRef: TemplateRef<any>) {
    this.taskListIDMoveTo = 0;
    this.ButtonForMoveTo = false;
    this.expandedIndexmoveTo = 0;
    this.taskListsForMoveTo = [];
    this.getTaskListFoldersForMoveTo();
    this.dialog.open(templateRef);
  }

  getTaskListFoldersForMoveTo() {
    this.loaderService.show();
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskListFolders(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskListFolderForMoveTo = response.data.taskListFolders;
        }
        else {
          this.taskListFolderForMoveTo = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskListFolderForMoveTo = [];
        this.loaderService.hide();
      }
    });
  }

  getTaskListsForMoveTo(tasklist: any, index: number) {
    this.ButtonForMoveTo = false;
    this.taskListsForMoveTo = [];
    this.expandedIndexmoveTo = index;
    this.loaderService.show();
    var ReqModel = {
      folderID: tasklist.taskListFolderID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.taskService.getTaskLists(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskListsForMoveTo = response.data.taskLists;
        }
        else {
          this.taskListsForMoveTo = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskListsForMoveTo = [];
        this.loaderService.hide();
      }
    });
  }

  SelectTaskList(Tasklist: any) {
    if (this.taskListID == Tasklist.taskListID) {
      this.toastr.warning('Task can not add same folder.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.taskListIDMoveTo = Tasklist.taskListID;
    this.ButtonForMoveTo = true;
  }

  MoveToTaskList() {
    var itemList = [];
    if (this.selectedRecordMoveToArray.length > 0) {
      for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i) {
        var obj = {
          taskID: this.selectedRecordMoveToArray[i].selectedRecord,
          position: i + 1
        }
        itemList.push(obj);
      }
    }
    var ReqModel = {
      taskListID: this.taskListIDMoveTo,
      tasks: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.spinner = true;
    this.ButtonForMoveTo = false;
    this.taskService.taskMovetoTaskList(ReqModel).subscribe((response) => {
      if (response.data == true) {
        this.spinner = false;
        this.toastr.success('Task moved successfully.', '', {
          timeOut: 3000,
        });
        this.closeMoveto();
        if (this.taskListID == 0) {
          this.getTaskList(this.pageModelData);
        } else {
          this.getTaskByTaskList();
        }
        this.selectedRecordMoveToArray = [];
        this.selection.clear();
      } else {
        this.toastr.error('Task move failed.', '', {
          timeOut: 3000,
        });
        this.spinner = false;
        this.ButtonForMoveTo = false;
      }
    })
  }

  AddTaskTemplateMultiple: Boolean = false;


  SaveAsTemplateMultiple(templateRef: TemplateRef<any>) {
    this.AddTaskTemplateMultiple = true;
    let group = {};
    this.addTemplateForm = new FormGroup(group);
    this.createSaveAsTaskTemplate();
    this.getActiveTaskTemplateCategories();
    this.dialog.open(templateRef);
  }


  async AddTaskTemplate(data) {
    var itemList = [];
    if (this.AddTaskTemplateMultiple == false) {
      itemList = null;
    }
    if (this.AddTaskTemplateMultiple == true) {
      this.taskListID = 0;
      if (this.selectedRecordMoveToArray.length > 0) {
        for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i) {
          var obj = {
            taskID: this.selectedRecordMoveToArray[i].selectedRecord,
            position: i + 1
          }
          itemList.push(obj);
        }
      }
    }

    this.loaderService.show();
    var ReqModel = {
      taskTemplateName: data.taskTemplateName,
      position: 0,
      folderID: data.folderID,
      taskListID: this.taskListID,
      tasks: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    //return; 
    this.spinner = true;
    this.addTemplateForm.markAsPristine();
    const result = await this.taskService.addTaskTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Task template added successfully.", '', {
        timeOut: 3000,
      });
      this.showMoveToOption = false;
      this.selectedRecordMoveToArray = [];
      this.selection.clear();
      this.closeSaveAsTemplate();
    }
    else {
      this.toastr.error("Task template add failed.", '', {
        timeOut: 3000,
      });
      this.showMoveToOption = false;
      this.spinner = false;
      this.loaderService.hide();
    }
  }

  ShowNoRecordFoundTaskTemplates: Boolean = false;
  TaskTemplatesList: any = [] = [];
  taskListIDforAddTemplate: number = 0;

  //  getUpdatedDate(dueDate) {
  //   if(dueDate!=null){ 
  //     const d = new Date(dueDate);
  //     d.setDate(d.getDate() - 1);
  //     // This will return an ISO string matching your local time.
  //      var date = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes() - d.getTimezoneOffset()).toISOString();
  //     return this.datePipe.transform(date,"MM/dd/yyyy");
  //    }  
  //   }

  encryptedUserToken: any;
  userToken: any;
  decodedUserData: any;


  onTaskListStatusChange($event: any, task: any) {

    let requestModal: any;
    this.encryptedUserToken = sessionStorage.getItem("userToken");
    this.userToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.encryptedUserToken);
    this.decodedUserData = jwt_decode(this.userToken);
    const email = this.encryptedUserToken = sessionStorage.getItem("email");

    let taskStatus = [{
      taskID: task.taskId,
      status: $event,
      position: task.position,
      userID: this.currentUser.UID,
      organizationID: 0,
      officeID: 0,
      officeIDList: [0],
      databaseID: 0
    }]

    let ReqModel = {
      taskListID: this.taskListID,
      isUpdateTaskListStatus: false,
      tasks: taskStatus,

      name: this.decodedUserData.Name,
      email: email,
      emailOfPersonDoingTask: email,
      entityTypeAttached: 0, //3C TYPE
      attachedEntityID: 0, // 3C id

      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
      officeIDList: [0],
      databaseID: 0
    }

    let taskStatusWithFilter = {
      taskID: task.taskId,
      status: $event,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: [0],
      databaseID: 0
    }



    if (this.IsAllTask == true || this.IsAssignedToMe == true || this.IsAssignedToMyRole == true || this.IsCreatedByMe == true) {
      this.formsService.UpdateSingleTaskStatus(taskStatusWithFilter).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success("Details updated successfully.");
          } else {
            this.loaderService.hide();
            this.toastr.error("Status updated failed.")
          }
        } else {
          this.loaderService.hide();
          this.toastr.success("Status updated failed.")
        }
      });

    } else {
      this.formsService.UpdateTaskOrTaskListstatus(ReqModel).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success("Details updated successfully.");
          } else {
            this.loaderService.hide();
            this.toastr.error("Status updated failed.")
          }
        } else {
          this.loaderService.hide();
          this.toastr.success("Status updated failed.")
        }
      });

    }


  }


  onTaskListPriorityChange($event: any, task: any) {
    this.encryptedUserToken = sessionStorage.getItem("userToken");
    this.userToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.encryptedUserToken);
    this.decodedUserData = jwt_decode(this.userToken);

    var ReqModel = {
      "taskID": task.taskId,
      "priority": $event,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "officeID": Number(this.myOfficeID),
      "officeIDList": [
        0
      ],
      "databaseID": 0
    }

    this.formsService.UpdateTaskPriority(ReqModel).subscribe((response) => {

      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {

          this.loaderService.hide();
          this.toastr.success("Details updated successfully.");

        } else {
          this.loaderService.hide();
          this.toastr.error("Status updated failed.")
        }
      } else {
        this.loaderService.hide();
        this.toastr.success("Status updated failed.")
      }
    });
  }



  SubmitColumnsButton: boolean = false;


  sendManualTaskReminder(templateRef: TemplateRef<any>, task: any) {
    this.SubmitColumnsButton = false;
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.repeatTaskEmail = "";
    this.getTaskDetailByID(task);

    if (task.taskId == undefined) {
      this.TaskReminderTaskId = task.taskID;
    } else {
      this.TaskReminderTaskId = task.taskId;
    }
    this.SubmitColumnsButton = false;
  }



  closeSendReminder() {
    this.SubmitColumnsButton = false;
    this.taslTemplateID = 0;
    this.taskListFolderID = 0;
    this.TaskReminderTaskId = 0;
    this.dialog.closeAll();
  }

  taskDetailList: any = [] = [];
  getTaskAssignedEntityInDetails: any = [] = [];
  getTaskAttachedEntityInDetails: any = [] = [];
  entityTypeAssignee: number = 2;
  taskAssignedEntity: any = [] = [];
  taskAttachedEntity: any = [] = [];
  repeatTaskEmail: string = "";
  TaskReminderTaskId: number = 0;
  entityTypeAttached: any;

  getTaskDetailByID(task) {
    var taskId = 0;
    if (task.taskId == undefined) {
      taskId = task.taskID;
    } else {
      taskId = task.taskId;
    }
    this.loaderService.show();
    var ReqModel = {
      taskID: taskId,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.coreService.getTaskDetailByID(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskDetailList = response.data;

          var data = JSON.parse(this.taskDetailList.notifyData);

          if (data != null) {
            this.repeatTaskEmail = data.NotifyEmails;
            this.SubmitColumnsButton = true;
            this.loaderService.hide();
            return;
          }
          this.getTaskAssignedEntityInDetails = this.taskDetailList.taskAssignedEntity;
          this.getTaskAttachedEntityInDetails = this.taskDetailList.taskAttachedEntity;

          this.entityTypeAssignee = this.taskDetailList.entityTypeAssignee;
          this.entityTypeAttached = this.taskDetailList.entityTypeAttached;


          if (this.getTaskAssignedEntityInDetails.length > 0) {
            // Contact-1,Role-2,Email-3,User-4,RelationShip-5
            // Added For Contact
            if (this.entityTypeAssignee == 1) {
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAssignedEntityInDetails[i].assigneeEmail != "") {
                  this.repeatTaskEmail += this.getTaskAssignedEntityInDetails[i].assigneeEmail + ',';
                }
              }
            }

            // Added For Email
            if (this.entityTypeAssignee == 3) {
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAssignedEntityInDetails[i].email != "") {
                  this.repeatTaskEmail += this.getTaskAssignedEntityInDetails[i].email + ',';
                }
              }
            }

            // Added For User
            if (this.entityTypeAssignee == 4) {
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAssignedEntityInDetails[i].assigneeEmail != "") {
                  this.repeatTaskEmail += this.getTaskAssignedEntityInDetails[i].assigneeEmail + ',';
                }
              }
            }
            if (this.entityTypeAssignee == 5) {
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAssignedEntityInDetails[i].assigneeEmail != "") {
                  this.repeatTaskEmail += this.getTaskAssignedEntityInDetails[i].assigneeEmail + ',';
                }
              }
            }
          }

          if (this.getTaskAttachedEntityInDetails.length > 0) {
            // Core-1,Contact-2,Company-3
            // Added For Core
            if (this.entityTypeAttached == 1) {
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAttachedEntityInDetails[i].attachedEntityEmail != "") {
                  this.repeatTaskEmail += this.getTaskAttachedEntityInDetails[i].attachedEntityEmail + ',';
                }
              }
            }

            // Added For Contact
            if (this.entityTypeAttached == 2) {
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAttachedEntityInDetails[i].attachedEntityEmail != "") {
                  this.repeatTaskEmail += this.getTaskAttachedEntityInDetails[i].attachedEntityEmail + ',';
                }
              }
            }

            // Added For Company
            if (this.entityTypeAttached == 3) {
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAttachedEntityInDetails[i].attachedEntityEmail != "") {
                  this.repeatTaskEmail += this.getTaskAttachedEntityInDetails[i].attachedEntityEmail + ',';
                }
              }
            }
          }

          this.repeatTaskEmail = this.repeatTaskEmail.replace(/,(\s+)?$/, '');
          this.SubmitColumnsButton = true;
          this.loaderService.hide();
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  onSendManualTaskReminder() {
    if (this.repeatTaskEmail == "") {
      this.toastr.warning('Please add email id.', '', {
        timeOut: 3000,
      });
      return;
    }
    var check = this.repeatTaskEmail;
    var newcheck: any = [];
    newcheck = check.split(',');
    for (var i = 0; i < newcheck.length; i++) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var checkemail = re.test(String(newcheck[i]).toLowerCase());
      if (checkemail == true) {
      } else {
        this.toastr.warning('Please provide valid email.', '', {
          timeOut: 3000,
        });
        return;
      }
    }
    var reqModel = {
      taskID: this.TaskReminderTaskId,
      emails: this.repeatTaskEmail,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.SubmitColumnsButton = false;
    this.loaderService.show();
    this.taskService.SendManualTaskReminderService(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success('Task reminder send successfully.', '', {
            timeOut: 3000,
          });
          this.closeSendReminder();
        } else {
          this.loaderService.hide();
          this.toastr.error('Task reminder failed.', '', {
            timeOut: 3000,
          });
          this.closeSendReminder();
        }
      } else {
        this.loaderService.hide();
        this.toastr.error('Task reminder failed.', '', {
          timeOut: 3000,
        });
        this.closeSendReminder();
      }
    });
  }



  //=============== Import Single Task =================//

  ////=============== For Single Task =================//
  TaskIdForSingleTask: number = 0;
  TaskTemplatesListForSingleTask: any = [] = [];
  TaskTemplatesListForSingleTaskFilter: any = [] = [];
  categoryTypeForSingleTask: number = 0;
  taskTemplateIDForSingleTask: number = 0;
  taskTitleForSingleTask: string = "";
  selectedTemplate: any = [] = [];
  taskListIDforImportTask: number = 0;
  showNew: boolean = false;
  showExisting: boolean = false;
  updateTaskTemplateTasksButton: boolean = false;
  filteredTaskCategoryList: any[] = [];
  categoryType: number = 0;
  timeout = null;
  searchTemplateName: string = "";
  taskTemplateNameForSingleTask: string = "";

  SaveAsTemplateForSingleTask(templateRef: TemplateRef<any>, tasklist: any) {
    this.categoryTypeForSingleTask = 0;
    this.taskTemplateIDForSingleTask = 0;
    this.AddTaskTemplateMultiple = false;
    this.taskTemplateNameForSingleTask = "";
    this.TaskIdForSingleTask = tasklist.taskId;
    this.taskTitleForSingleTask = tasklist.taskTitle;
    this.createSaveAsTaskTemplate();
    this.showNew = true;
    this.showExisting = false;
    this.getActiveTaskTemplateCategories();
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  OnCategoryChangeForSingleTask(categoryTypeValue: number) {
    this.categoryTypeForSingleTask = categoryTypeValue;
    this.getTaskTemplatesForSingleTask();
  }

  getTabDetailsForSingleTask(event) {
    this.updateTaskTemplateTasksButton = false;
    this.taslTemplateID = 0;
    this.selectedTemplate = [];
    this.createSaveAsTaskTemplate();
    this.getActiveTaskTemplateCategories();
    if (event.tab.textLabel == "New" || event.index == 0) {
      this.showNew = true;
      this.showExisting = false;
    }

    if (event.tab.textLabel == "Update Existing" || event.index == 1) {
      this.showNew = false;
      this.showExisting = true;
      this.selectedTaskCategoryID = 0;
      this.getTaskTemplatesForSingleTask();
    }
  }

  getTaskTemplatesForSingleTask() {
    this.ShowNoRecordFoundTaskTemplates = false;
    this.loaderService.show();
    var ReqModel = {
      transaction: {
        transactionID: this.transactionIDForTask,
        typeId: this.typeIdForTask
      },
      categoryID: Number(this.selectedTaskCategoryID),
      templateType: Number(this.categoryTypeForSingleTask),
      userID: this.currentUser.UID,
      officeID: Number(this.myOfficeID),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.taskService.getSingleTaskTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.TaskTemplatesListForSingleTask = response.data.tasks;
          this.TaskTemplatesListForSingleTaskFilter = response.data.tasks;
          // if(this.categoryType==0){
          //   this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 0);
          //   const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          //   this.FilteredTaskTemplatesList = this.TaskTemplatesListForSingleTask.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          // }
          // if(this.categoryType==1){
          //   this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 1);
          //   const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          //   this.FilteredTaskTemplatesList = this.TaskTemplatesListForSingleTask.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          // }
          // if(this.categoryType==2){
          //   this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 2);
          //   const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          //   this.FilteredTaskTemplatesList = this.TaskTemplatesListForSingleTask.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          // }
          if (this.TaskTemplatesListForSingleTask.length > 0) {
            this.ShowNoRecordFoundTaskTemplates = false;
          } else {
            this.ShowNoRecordFoundTaskTemplates = true;
          }
        }
        else {
          this.ShowNoRecordFoundTaskTemplates = true;
          this.TaskTemplatesListForSingleTask = [];
          this.loaderService.hide();
        }
      }
      else {
        this.TaskTemplatesListForSingleTask = [];
        this.ShowNoRecordFound = true;
        this.loaderService.hide();
      }
    });
  }

  closeSaveAsTemplateForSingleTask() {
    this.taskTemplateIDForSingleTask = 0;
    this.addTemplateForm.reset();
    this.taskListFolderID = 0;
    this.dialog.closeAll();
  }


  getSelectTaskCategoryForSingleTask(e: any) {
    this.selectedTaskCategoryID = e.value;
    this.updateTaskTemplateTasksButton = false;
    this.getTaskTemplatesForSingleTask();
  }


  openDialogAddWithRef() {
    const dialogRef = this.dialog.open(AddTaskTempCategoryComponent, {
      data: {
        categoryType: this.categoryType
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getActiveTaskTemplateCategoriesAfterAdd(result);
      }
    });
  }

  getActiveTaskTemplateCategoriesAfterAdd(categoryName: string) {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.taskService.getActiveTaskTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskCategoryList = response.data;
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
          var check = [];
          check = this.taskCategoryList.filter(x => x.taskTemplateCategoryName.toLowerCase() == categoryName.toLowerCase());
          if (check.length > 0) {
            this.addTemplateForm.controls['folderID'].setValue(check[0].taskTemplateCategoryID);
          }
        }
        else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      }
      else {
        this.taskCategoryList = [];
        this.filteredTaskCategoryList = [];
      }
    });
  }

  searchTemplate(val) {
    if (val.length >= 2) {
      if (val != '') {
        // clearTimeout(this.timeout)
        // this.timeout = setTimeout(() => {
        //   this.searchTemplateName = val;
        //   this.getTaskTemplates();
        // }, 500);
      } else {
      }
    } else {
      //this.searchTemplateName = "";
      //this.getTaskTemplates();
    }
  }


  SelectTemplateForAddTaskListForSingleTask(temp: any) {
    this.taskTemplateIDForSingleTask = temp.taskId;
    this.taskTemplateNameForSingleTask = temp.taskTitle;
    this.updateTaskTemplateTasksButton = true;
  }


  async AddTaskTemplateForSingleTask(data) {
    this.loaderService.show();
    var ReqModel = {
      taskID: this.TaskIdForSingleTask,
      singleTaskTemplateID: 0,
      templateName: data.taskTemplateName,
      categoryID: Number(data.folderID),
      templateType: this.categoryTypeForSingleTask,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    //return; 
    this.spinner = true;
    this.addTemplateForm.markAsPristine();
    const result = await this.taskService.addSingleTaskTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Task template added successfully.", '', {
        timeOut: 3000,
      });
      this.getTaskList(this.pageModelData);
      this.closeSaveAsTemplateForSingleTask();
    }
    else {
      this.toastr.error("Task template add failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }


  async AddSingleTaskTemplateForSingleTask(data) {
    this.loaderService.show();
    var ReqModel = {
      taskID: this.TaskIdForSingleTask,
      singleTaskTemplateID: this.taskTemplateIDForSingleTask,
      templateName: this.taskTemplateNameForSingleTask,
      categoryID: Number(this.selectedTaskCategoryID),
      templateType: this.categoryTypeForSingleTask,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    }
    // return; 
    this.spinner = true;
    this.updateTaskTemplateTasksButton = false;
    const result = await this.taskService.addSingleTaskTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Single task import successfully.", '', {
        timeOut: 3000,
      });
      this.getTaskList(this.pageModelData);
      this.closeSaveAsTemplateForSingleTask();
    }
    else {
      this.toastr.error("Single task import failed.", '', {
        timeOut: 3000,
      });
      this.showMoveToOption = false;
      this.spinner = false;
      this.loaderService.hide();
    }
  }

  searchTemplateForSingleTask(val) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.TaskTemplatesListForSingleTask = this.TaskTemplatesListForSingleTaskFilter.filter(i => i.templateName.toLowerCase().indexOf(val.toLocaleLowerCase()) !== -1);
        }, 500);
      } else {

      }
    } else {
      this.searchTemplateName = "";
      this.getTaskTemplatesForSingleTask();
    }
  }







  //================Import Single Task ============//
  currentIndex: number = 0;

  ImportTaskTemplate(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.AttachChecked = false;
    this.AssigneeChecked = false;
    this.NotifyChecked = false;
    this.categoryTypeForSingleTask = 0;
    this.currentIndex = 0;
    this.selectedTemplate = [];
    this.taskListIDforImportTask = 0;
    this.getTaskTemplatesForSingleTask();
    this.selectedTaskCategoryID = 0;
    this.categoryType = 0;
    this.searchTemplateName = "";
    this.getActiveTaskTemplateCategories();
  }

  ImportTaskTemplateFromTaskList(templateRef: TemplateRef<any>, list: any) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.categoryTypeForSingleTask = 0;
    this.currentIndex = 0;
    this.selectedTemplate = [];
    this.taskListIDforImportTask = Number(list.taskListID);
    this.getTaskTemplatesForSingleTask();
    this.selectedTaskCategoryID = 0;
    this.categoryType = 0;
    this.searchTemplateName = "";
    this.getActiveTaskTemplateCategories();
  }



  onTaskListTabChangeForTaskImport($event) {
    this.selectedTaskCategoryID = 0;
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;
    this.categoryTypeForSingleTask = categoryValue;
    this.getTaskTemplatesForSingleTask();
  }

  getTaskListThroughCategoryForTaskImport(e: any, i: any) {
    this.selectedTemplate = [];
    this.currentIndex = i
    //his.categoryTypeForSingleTask = e;
    this.selectedTaskCategoryID = e;
    this.getTaskTemplatesForSingleTask();
  }

  //Checkbox Change detecting function
  getCheckboxValues(event, template) {
    if (event.checked) {
      this.selectedTemplate.push(template);
    } else {
      let removeIndex = this.selectedTemplate.findIndex((itm) => itm === template);
      if (removeIndex !== -1) this.selectedTemplate.splice(removeIndex, 1);
    }
    if (this.selectedTemplate.length == 0) {
    }
  }


  async importTaskTemplates() {
    this.loaderService.show();
    var taskIdss = [];
    if (this.selectedTemplate.length > 0) {
      for (let i = 0; i < this.selectedTemplate.length; i++) {
        taskIdss.push(this.selectedTemplate[i].taskId);
      }
    }
    var taskListIDforImportTask = 0;
    if (this.taskListIDforImportTask > 0) {
      taskListIDforImportTask = this.taskListIDforImportTask;
    } else {
      taskListIDforImportTask = 0;
    }

    var ReqModel = {
      "attachDetails": {
        "entityID": this.entityId,
        "cType": this.typeIdForTask,
        "name": this.name,
        "email": this.email,
        "entityTypeID": this.TypeIdDrp
      },
      taskIds: taskIdss,
      taskListID: Number(taskListIDforImportTask),
      transaction: {
        transactionID: this.transactionIDForTask,
        typeId: this.typeIdForTask
      },
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      keepAttached: this.AttachChecked,
      keepAssignee: this.AssigneeChecked,
      keepNotify: this.NotifyChecked,
    }
    // return;
    this.spinner = true;
    const result = await this.taskService.importTaskFromTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();
      this.toastr.success("Task Imported successfully.", '', {
        timeOut: 3000,
      });
      this.getTaskList(this.pageModelData);
      this.closeImportTaskTemplate();
    }
    else {
      this.toastr.error("Task Import failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }

  closeImportTaskTemplate() {
    this.selectedTemplate = [];
    this.taskListFolderID = 0;
    this.taskListIDforImportTask = 0;
    this.selectedTaskCategoryID = 0;
    this.searchTemplateName = "";
    this.categoryType = 0;
    this.dialog.closeAll();
  }


  // ======== Archived ============//

  currentTaskListArchived: number = 0;
  taskListSelectedArchived = false;
  taskListsArchived: any = [] = [];
  expandedIndexArchived: number = 0;
  taskListIDArchived: number = 0;


  ArchiveTask(task) {
    this.taskListSelectedArchived = true;
    this.taskListsArchived = [];
    const message = `Are you sure you want to archive this task?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var taskId = 0;
          if (task.taskId == undefined) {
            taskId = task.taskID;
          } else {
            taskId = task.taskId;
          }
          var reqModel = {
            taskIds: [taskId],
            isArchived: true,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.archivedTask(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                if (this.taskListID == 0) {
                  this.pageIndex = 1;
                  this.pageSize = 300;
                  this.getTaskList(this.pageModelData);
                } else {
                  this.getTaskByTaskList();
                }
                this.loaderService.hide();
                this.toastr.success('Task archived successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task archived failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task archived failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  UnArchiveTask(task) {
    this.taskListSelectedArchived = true;
    this.taskListsArchived = [];
    const message = `Are you sure you want to Unarchive this task?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var taskId = 0;
          if (task.taskId == undefined) {
            taskId = task.taskID;
          } else {
            taskId = task.taskId;
          }
          var reqModel = {
            taskIds: [taskId],
            isArchived: false,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.taskService.archivedTask(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                if (this.taskListID == 0) {
                  this.pageIndex = 1;
                  this.pageSize = 300;
                  this.getTaskListSingleTask(this.pageModelData);
                } else {
                  this.getTaskByTaskList();
                }
                this.loaderService.hide();
                this.toastr.success('Task Unarchived successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task Unarchived failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task Unarchived failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  AttachChecked: boolean = false;
  AssigneeChecked: boolean = false;
  NotifyChecked: boolean = false;


  showOptions(event: MatCheckboxChange, data): void {
    if (data == "Attach") {
      this.AttachChecked = event.checked;
    }
    if (data == "Assignee") {
      this.AssigneeChecked = event.checked;
    }
    if (data == "Notify") {
      this.NotifyChecked = event.checked;
    }
  }

  taskListIDSharedWithMe: number = 0;

  getAttach(item: any) {

    const allAttach = [];
    if (item) {
      item.forEach(item => {
        allAttach.push(item.attachedEntityName);
      })
    }
    return allAttach ? allAttach : "-"

    //return item[0]?.attachedEntityName ? item[0]?.attachedEntityName : "-"
  }

  getAssigne(item: any) {
    const allAssignee = [];
    if (item && item.length > 1) {
      item.forEach(item => {
        if (item.assigneeName) {
          allAssignee.push({ name: item.assigneeName, image: item.imageUrl });
        } else if (item.roleName) {
          allAssignee.push({ name: item.roleName, image: item.imageUrl });
        } else if (item.email) {
          allAssignee.push({ name: item.email, image: item.imageUrl });
        }
      })
    } else {
      if (item[0]?.assigneeName) {
        allAssignee.push({ name: item[0].assigneeName, image: item[0].imageUrl });
      } else if (item[0]?.roleName) {
        allAssignee.push({ name: item[0].roleName, image: item[0].imageUrl });
      } else if (item[0]?.email) {
        allAssignee.push({ name: item[0].email, image: item[0].imageUrl });
      }
    }
    return allAssignee;
  }

  getShortName(fullName) {
    if (fullName != undefined) {
      if (fullName.includes(' ')) {
        return fullName
          .split(' ')
          .map((n) => n[0])
          .join('');
      }
      return fullName.substring(0, 1);
    }
    return '';
  }


  trackByFn(index, item) {
   return index; // or item.id
  }

  dropItem(event: CdkDragDrop<string[]>) {
    event.item.data.taskGroupId = Number(event.container.id);
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      //this.dropTable();
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      //this.dropTable();
    }
  }

  getConnectedList(): any[] {
    return this.columns[0].groups.map((x) => `${x.id}`);
    // return this.columns.map((x) => `${x.id}`);
  }


  dropGroup(event: CdkDragDrop<string[]>) {
    //Default Group
    // if(event.item.data.title!='Default Group' && event.currentIndex<(this.columns[0].groups.length-1))
    // {
    moveItemInArray(this.columns[0].groups, event.previousIndex, event.currentIndex);
    var newGroup = [];
    newGroup = this.columns[0].groups.filter(x => x.id > 0);

    var itemList = [];
    if (newGroup.length > 0) {
      //newGroup=newGroup.reverse();
      for (var i = 0, len = newGroup.length; i < len; ++i) {
        var obj = {
          position: i + 1,
          taskGroupID: newGroup[i].id,
        }
        itemList.push(obj);
      }
    }
    //return;
    var ReqModel = {
      taskListID: this.taskListID,
      taskGroups: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
     this.taskService.reorderTaskGroup(ReqModel).subscribe((response) => {
       if (response != undefined) {
         this.responseHolder = response;
         if (this.responseHolder.status == this.statusConst.statusSuccess) {
           this.getTaskByTaskList();
           this.loaderService.hide();
         } else {
           this.loaderService.hide();
         }
       } else {
         this.loaderService.hide();
       }
     });
    // }else{
    //   this.toastr.warning("Can't move default group or any group below default group.");
    // }
  }


  removeGroup(task: any) {
    const message = `Are you sure you want to delete this group and all associated tasks?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var ReqModel = {
            groupID: task.id,
            taskListID: this.taskListID,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
           this.loaderService.show();
           this.taskService.removeTaskGroup(ReqModel).subscribe((response) => {
             if (response != undefined) {
               this.responseHolder = response;
               if (this.responseHolder.status == this.statusConst.statusSuccess) {
                 this.responseHolder = response;
                 this.toastr.success('Group removed successfully.', '', {
                   timeOut: 3000,
                 });
                 this.loaderService.hide();
                 this.getTaskByTaskList();
               } else {
                 this.loaderService.hide();
               }
             } else {
               this.loaderService.hide();
             }
           });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }



  ChangeGroupType(event: MatRadioChange, task: any, groupType) {
    var message;
    if (groupType == 0) {
      message = `Are you sure you want to change group type as normal for this group? and this changed will be set for all previous groups`;
    }
    if (groupType == 1) {
      message = `Are you sure you want to change group type as trigger for this group? and this changed will be set for all next groups`;
    }
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          var ReqModel = {
            groupID: task.id,
            taskListID: this.taskListID,
            groupType: groupType,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            databaseID: this.databaseId
          }
          // this.taskService.changeGroupType(ReqModel).subscribe(response => {
          // if (response != undefined) {
          //   this.responseHolder = response;
          //   this.loaderService.hide();
          //   if (this.responseHolder.status == this.statusConst.statusSuccess) {             
          //     this.toastr.success("Task Group Trigger successfully.");      
          //     this.getTaskByTaskList();
          //     // 1 For set Trigger
          //     if(groupType==1){
          //       this.taskListForGroupTrigger;
          //       var index = this.taskListForGroupTrigger.findIndex(x => x.taskGroupId === task.id);           
          //       var newTaskListGroup=[];
          //       if(this.taskListForGroupTrigger.length>0){
          //         var nextIndex =index + 1;
          //         for (var i = nextIndex, len = this.taskListForGroupTrigger.length; i < len; ++i) {
          //           if(this.taskListForGroupTrigger[i].groupType==0){
          //             var obj={
          //               groupPosition:this.taskListForGroupTrigger[i].groupPosition,
          //               groupType:this.taskListForGroupTrigger[i].groupType,
          //               isTriggered:this.taskListForGroupTrigger[i].isTriggered,
          //               taskGroupId:this.taskListForGroupTrigger[i].taskGroupId,
          //               taskGroupName:this.taskListForGroupTrigger[i].taskGroupName,
          //             } 
          //             newTaskListGroup.push(obj);
          //           }               
          //         }
          //         if(newTaskListGroup.length>0){
          //          for (var i1 = 0, len1 = newTaskListGroup.length; i1 < len1; ++i1) {
          //            this.ChangeGroupTypeMultiple(newTaskListGroup[i1],1); //1 For set Trigger
          //          }
          //         }
          //       }          
          //     }
          //      // 0 For set Normal
          //     if(groupType==0){
          //       this.taskListForGroupTrigger;
          //       var index = this.taskListForGroupTrigger.findIndex(x => x.taskGroupId === task.id);           
          //       var newTaskListGroup=[];
          //       if(this.taskListForGroupTrigger.length>0){
          //         var nexttIndex =index - 1;
          //         for (var i2 = nexttIndex; i2 >= 0; --i2){
          //           if(i2>0){
          //           if(this.taskListForGroupTrigger[i2].taskGroupId!=0){
          //             var obj={
          //               groupPosition:this.taskListForGroupTrigger[i2].groupPosition,
          //               groupType:this.taskListForGroupTrigger[i2].groupType,
          //               isTriggered:this.taskListForGroupTrigger[i2].isTriggered,
          //               taskGroupId:this.taskListForGroupTrigger[i2].taskGroupId,
          //               taskGroupName:this.taskListForGroupTrigger[i2].taskGroupName,
          //             } 
          //             newTaskListGroup.push(obj);
          //           }
          //          }           
          //         }
          //         if(newTaskListGroup.length>0){
          //          for (var i1 = 0, len1 = newTaskListGroup.length; i1 < len1; ++i1) {
          //            this.ChangeGroupTypeMultiple(newTaskListGroup[i1],0); //0 For set Normal
          //          }
          //         }
          //       }          
          //     }
          //   }else {
          //     this.loaderService.hide();
          //   }
          //    }else {
          //     this.loaderService.hide();
          //    }
          //   });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  AllTypeList: any = [] = [];

  getFieldColumnValues(FieldColumn, item) {
    if (item.customFieldsData != null) {

      var data = [];
      data = item.customFieldsData?.fields.filter(x => x.fieldID == FieldColumn.fieldID);
      if (data != undefined) {
        if (data.length > 0) {
          if (data[0].fieldName == "Type" && data[0].fieldTypeName == "Dropdown") {
            var checkdrp = []
            checkdrp = this.AllTypeList.filter(x => x.subFolderID == Number(data[0].fieldValue))
            if (checkdrp.length > 0) {
              return checkdrp[0].folderName;
            } else {
              return '--';
            }
          }
          if (data[0].fieldTypeName == "Date") {
            if (data[0].fieldValue != "") {
              return this.datePipe.transform(data[0].fieldValue, 'MM-dd-yyyy');;
            } else {
              return '--';
            }
          }
          if (data[0].fieldValue != "") {
            return data[0].fieldValue;
          } else {
            return '--';
          }
        } else {
          return '--';
        }
      }

    }
  }

  values: string = "";

  onChangeGroupName(event: any, group: any) {
    this.values = event.target.value;
    if (this.values == "") {
      this.toastr.warning("Group name can not be blank.", '', {
        timeOut: 3000,
      });
    }
    if (event != undefined && this.values != "") {
      this.loaderService.show();
      var ReqModel = {
        groupID: group.id,
        groupName: this.values,
        position: 1,
        taskListID: this.taskListID,
        userID: this.currentUser.UID,
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),
        officeIDList: this.OfficeIDList,
        databaseID: this.databaseId
      }
      //return;
      this.taskService.addEditTaskGroup(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Group renamed successfully.', '', {
              timeOut: 3000,
            });
            this.loaderService.hide();
            this.getTaskByTaskList();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  };


  MakeTaskRequired(task: any, isRequired) {
    this.loaderService.show();
    var ReqModel = {
      taskIDs: [task.taskId],
      isRequired: isRequired,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: this.databaseId
    }
    this.taskService.makeTaskRequired(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          task.isRequired = true;
          if (isRequired == true) {
            this.toastr.success("Task required successfully.");
          }
          if (isRequired == false) {
            this.toastr.success("Task unrequired successfully.");
          }
          if (this.taskListID == 0) {
            this.getTaskList(this.pageModelData);
          } else {
            this.getTaskByTaskList();
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

   createGroup() {
      this.loaderService.show();     
        var ReqModel = {
        groupID: 0,
        groupName: "Group1",
        position: (Math.max(...(this.columns[0].groups.map(m => m.groupPosition))) + 1),
        taskListID:this.taskListID,
        userID: this.currentUser.UID,
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),
        officeIDList: this.OfficeIDList,
        databaseID: this.databaseId
      }
      //return; 
      this.taskService.addEditTaskGroup(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.toastr.success('Group added successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskByTaskList();
          this.loaderService.hide();
          }
        else {
          this.loaderService.hide();
        }
      });
    }

  // searchTemplateForSingleTask(val) {
  //   if (val.length >= 2) {
  //     if (val != '') {
  //       clearTimeout(this.timeout)
  //       this.timeout = setTimeout(() => {        
  //       this.TaskTemplatesListForSingleTask = this.TaskTemplatesListForSingleTaskFilter.filter(i => i.taskTitle.toLowerCase().indexOf(val.toLocaleLowerCase()) !== -1);
  //       }, 500);
  //     } else {

  //     }
  //   } else {
  //     this.searchTemplateName = "";  
  //     this.getTaskTemplatesForSingleTask();    
  //   }
  // }







  // sendManualTaskReminder(task) {
  //   const message = `Are you sure you want to send reminder for this task?`;
  //   const title = `Confirm`;
  //   const dialogData = new ConfirmDialogModel(title, message);   
  //   const dialogRef = this.dialog.open(ConfirmDialogComponent, {
  //     panelClass: 'edituserdetails',
  //     maxWidth: '1000px',
  //     maxHeight: '500px',
  //     data: dialogData,
  //   });
  //   dialogRef.beforeClosed().subscribe(async (dialogResult) => {
  //     try {
  //       if (dialogResult) { 
  //         var taskId=0;
  //         if(task.taskId == undefined){
  //           taskId=task.taskID;
  //         }else{
  //           taskId=task.taskId;
  //         }
  //         var reqModel={
  //           taskID: taskId,   
  //           emails: 'jenny@mailinator.com,jeremy@mailinator.com',       
  //           userID: this.currentUser.UID,  
  //           officeID: this.myOfficeID,    
  //           organizationID: Number(this.organizationId),
  //           officeIDList: this.OfficeIDList,
  //           databaseID:this.databaseId
  //         }          
  //         this.loaderService.show();
  //         this.taskService.SendManualTaskReminderService(reqModel).subscribe((response) => {
  //           if (response != undefined) {
  //             this.responseHolder = response;
  //             if (this.responseHolder.status == this.statusConst.statusSuccess) {
  //               this.loaderService.hide();
  //               this.toastr.success('Task reminder send successfully.', '', {
  //                 timeOut: 3000,
  //               });
  //              } else {
  //               this.loaderService.hide();
  //               this.toastr.error('Task reminder failed.', '', {
  //                 timeOut: 3000,
  //               });
  //             }
  //           } else {
  //             this.loaderService.hide();
  //             this.toastr.error('Task reminder failed.', '', {
  //               timeOut: 3000,
  //             });
  //           }
  //         });
  //       }
  //     } catch (e) {
  //       Observable.throw(e);
  //     }
  //   });
  // }


  columns = [
    {
      id: 0,
      title: "",
      groups: [
        // {
        //   id: 1,
        //   title: 'Group 1',
        //   items: [
        //     {
        //       "completedTaskCount": 1,
        //       "inprogressTaskCount": 2,
        //       "taskId": 839,
        //       "taskTitle": "ewqe",
        //       "dueDate": "2022-12-30T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-30T16:12:20.0127548",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 823,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:37.5893446",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 822,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:36.6103009",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
        // {
        //   id: 3,
        //   title: 'Group 3',
        //   items: [
        //     {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 820,
        //       "taskTitle": "avv1",
        //       "dueDate": "2022-11-27T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-28T18:12:16.8375494",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 349,
        //       "taskTitle": "test neu cores23445",
        //       "dueDate": "2022-11-25T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:33:58.1130724",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 348,
        //       "taskTitle": "Testing add from core234",
        //       "dueDate": "2022-11-24T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:21:26.8596399",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
      ],
    },

  ];

  columnsCopy = [
    {
      id: 0,
      title: "",
      groups: [
        // {
        //   id: 1,
        //   title: 'Group 1',
        //   items: [
        //     {
        //       "completedTaskCount": 1,
        //       "inprogressTaskCount": 2,
        //       "taskId": 839,
        //       "taskTitle": "ewqe",
        //       "dueDate": "2022-12-30T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-30T16:12:20.0127548",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 823,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:37.5893446",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 822,
        //       "taskTitle": "Testing add from core",
        //       "dueDate": null,
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-12-14T15:49:36.6103009",
        //       "parentID": 0,
        //       "status": 0,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
        // {
        //   id: 3,
        //   title: 'Group 3',
        //   items: [
        //     {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 820,
        //       "taskTitle": "avv1",
        //       "dueDate": "2022-11-27T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-28T18:12:16.8375494",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 349,
        //       "taskTitle": "test neu cores23445",
        //       "dueDate": "2022-11-25T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:33:58.1130724",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#db241c",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },
        //   {
        //       "completedTaskCount": 0,
        //       "inprogressTaskCount": 0,
        //       "taskId": 348,
        //       "taskTitle": "Testing add from core234",
        //       "dueDate": "2022-11-24T18:30:00",
        //       "priority": 0,
        //       "position": 0,
        //       "createDate": "2022-11-25T18:21:26.8596399",
        //       "parentID": 0,
        //       "status": 4,
        //       "entityTypeAttached": 0,
        //       "entityTypeAssignee": 0,
        //       "description": null,
        //       "formType": 0,
        //       "projectID": 0,
        //       "documentFolderID": 0,
        //       "attachedEntityID": 0,
        //       "colourCode": null,
        //       "action": 0,
        //       "formLink": null,
        //       "tags": null,
        //       "organizationID": 0,
        //       "officeID": 0,
        //       "color": "#B36AE2",
        //       "isInternal": true,
        //       "taskGroupId": 0,
        //       "isDeleted": false,
        //       "subTaskCount": 0,
        //       "completedSubTaskCount": 0,
        //       "taskAssignedEntity": null,
        //       "subTasks": null,
        //       "taskAttachedEntity": null,
        //       "taskAttachedEntityMapping": null
        //   },

        //   ],
        // },
      ],
    },

  ];


}

